/* @jsx h */
import { defineComponent, h } from "vue";
import { RouterLink } from "vue-router";
import { useLocalization } from "@lemmonhq/uikit";

export const RestaurantActions = defineComponent({
  props: {
    orderUrl: {
      type: String,
      required: true,
    },
    reserveUrl: {
      type: String,
      required: true,
    },
    onlineOrderingEnabled: {
      type: Boolean,
      required: true,
    },
    deliveryEnabled: {
      type: Boolean,
      required: true,
    },
    pickupEnabled: {
      type: Boolean,
      required: true,
    },
    reservationEnabled: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const { t } = useLocalization();
    return () => (
      <div class="flex flex-col sm:flex-row gap-4 justify-center mb-16">
        {(props.onlineOrderingEnabled ||
          props.deliveryEnabled ||
          props.pickupEnabled) && (
          <RouterLink
            to={props.orderUrl}
            class="group px-10 py-4 border-2 border-gray-900 text-gray-900 text-lg font-medium transition-all duration-300 hover:bg-gray-900 hover:text-white text-center"
          >
            <span class="material-symbols-outlined text-xl mr-3 align-middle">
              shopping_cart
            </span>
            {t("customer.restaurant_profile.order_online")}
            <span class="ml-2 group-hover:translate-x-1 transition-transform duration-300 inline-block">
              →
            </span>
          </RouterLink>
        )}

        {props.reservationEnabled && (
          <RouterLink
            to={props.reserveUrl}
            class="group px-10 py-4 border-2 border-gray-300 text-gray-700 text-lg font-medium transition-all duration-300 hover:border-gray-400 text-center"
          >
            <span class="material-symbols-outlined text-xl mr-3 align-middle">
              calendar_month
            </span>
            {t("customer.restaurant_profile.make_reservation")}
            <span class="ml-2 group-hover:translate-x-1 transition-transform duration-300 inline-block">
              →
            </span>
          </RouterLink>
        )}
      </div>
    );
  },
});
